export default {
  flattenObject (object) {
    var toReturn = {}

    for (var i in object) {
      if (!object.hasOwnProperty(i)) continue

      if (typeof object[i] === 'object') {
        var flatObject = this.flattenObject(object[i])

        for (var x in flatObject) {
          if (!flatObject.hasOwnProperty(x)) continue
          toReturn[i + '.' + x] = flatObject[x]
        }
      } else {
        toReturn[i] = object[i]
      }
    }
    return toReturn
  },
  createHeaderString (headers) {
    var headerStr = ''
    headers.forEach(h => {
      headerStr += h.header + ','
    })
    headerStr += '\r\n'
    return headerStr
  },
  convertToCSV (objArray, headers) {
    var array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray

    this.csvStr = this.createHeaderString(headers)

    for (var i = 0; i < array.length; i++) {
      var line = ''
      var object = this.flattenObject(array[i])

      headers.forEach(h => {
        if (line !== '') line += ','
        line += object[h.field] ? `"${object[h.field]}"` : '""'
      })

      this.csvStr += line + '\r\n'
    }
    return this.csvStr
  },
  exportCSVFile (fileTitle, objArray, headers) {
    /* if (headers) {
      items.unshift(headers);
    } */

    // var breedingCSV = this.convertToCSV(this.flattenEntires_shows(this.entries.filter(s => { return s.classType === 'BREEDING' })), this.breedingHeaders)
    // var marketCSV = this.convertToCSV(this.flattenEntires_shows(this.entries.filter(s => { return s.classType === 'MARKET' })), this.marketHeaders)
    // var showmanshipCSV = this.convertToCSV(this.flattenEntires_shows(this.entries.filter(s => { return s.classType === 'SHOWMANSHIP' })), this.showmanshipHeaders)
    let csvData = this.convertToCSV(objArray, headers)
    var toDownload = [{
      csv: csvData,
      fileName: fileTitle + '.csv' || 'export.csv'
    }]

    toDownload.forEach(d => {
      var blob = new Blob([d.csv], {type: 'text/csv;charset=utf-8;'})
      if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, d.fileName)
      } else {
        var link = document.createElement('a')
        if (link.download !== undefined) { // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob)
          link.setAttribute('href', url)
          link.setAttribute('download', d.fileName)
          link.style.visibility = 'hidden'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
      }
    })
  }
}
